// The broker audience is the Auth0 API the SPA requests an access token for to
// use as the token-exchange subject. It is the same value in every environment
// (the broker API is registered under one identifier across Auth0 tenants).
export const BROKER_AUDIENCE = 'https://auth.usemaia.com';

export const API_CONSTANTS = {
  BASE_URL: import.meta.env.VITE_API_USER_URL,
  RULES_BASE_URL: import.meta.env.VITE_API_RULE_URL,
  MAIA_API_BASE_URL: import.meta.env.VITE_MAIA_API_URL,
  BROKER_URL: import.meta.env.VITE_BROKER_URL,
  ENDPOINTS: {
    HOSPITALS: {
      LIST: '/hospitals/list',
    },
    MAIA_API: {
      ME: '/v1/me',
      USERS: '/v1/users',
      INVITES: '/v1/invites',
      PASSWORD_RESETS: '/v1/password-resets',
    },
    MAIA_FEATURE_FLAG: {
      BASE: '/v1/feature-flags',
    },
    PAYERS: {
      LIST: '/payers',
    },
    FIELDS: {
      LIST: '/sources/platform/operators',
    },
    RULES: {
      CREATE: '/rules',
      GET_BY_ID: '/rules',
      UPDATE: '/rules',
      // Combined overview by check type endpoint
      OVERVIEW_BY_CHECK_TYPE: '/rules/overview/by-check-type',
    },
    BATCH_JOBS: {
      CREATE: '/appointment-batch-jobs',
      CANCEL: '/appointment-batch-jobs/cancel',
      EXPORT_RESULTS: '/e-m/export/enm-results',
      SCHEDULE: '/appointment-batch-jobs/schedule',
    },
  },
} as const;

export const API_HEADERS = {
  CONTENT_TYPE: 'application/json',
  AUTHORIZATION: 'Authorization',
  TENANT_ID: 'X-Tenant-ID',
} as const;
